export default __webpack_public_path__ + "static/media/MySLR_results.e18a61e8.mp4";